// Module
var code = "<div class=\"flex-layout -items-center spacer-box -p-v-eq-15 border-box -top-eq-2 -brand-color-50\"> <h3 class=\"item -grow text-style -h3\">[[title]]</h3> <svg class=\"item -content svg-icon text-style -brand-color transform-style [[{ '-flipY': !collapsed }]] transition-style\"> <use xlink:href=\"#svg-ArrowDown\"/> </svg> </div> ";
// Exports
export default code;